import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { flowcodeApi } from '../../redux/slices/flowcodeApiSlice/init'
import { flowpageApi } from '../../redux/slices/flowpageApiSlice/empty'
import { getHeap } from '@dtx-company/true-common/src/utils/heap'
import { printStoreApi } from '../../redux/slices/printStoreApiSlice/init'
import { resetPageEditorSlice } from '../../redux/slices/pageEditor/pageEditorSlice'
import { resetPrintStoreSlice } from '../../redux/slices/printStoreApiSlice/printStoreSlice'
import { useCloseContextMenus } from '../useCloseContextMenus'
import { useDispatch } from 'react-redux'
import { useLogoutMethod } from '../../hooks/auth/useLogoutMethod'
import { useRouter } from 'next/router'

export function useLogout(): () => Promise<void> {
  const closeMenus = useCloseContextMenus()
  const logout = useLogoutMethod()
  const dispatch = useDispatch()
  const { push } = useRouter()
  const handleSignOut = async (): Promise<void> => {
    try {
      await logout()

      closeMenus()
      dispatch(resetPageEditorSlice())
      dispatch(resetPrintStoreSlice())
      dispatch(flowpageApi.util.resetApiState())
      dispatch(flowcodeApi.util.resetApiState())
      dispatch(printStoreApi.util.resetApiState())

      // Reset a user’s identity to an anonymous state after they have logged out
      const heap = getHeap()
      if (heap) {
        heap.resetIdentity()
      }

      push(Routes.SIGN_IN)
    } catch (e) {
      console.error(e)
    }
  }

  return handleSignOut
}
